import { QueryClientProvider } from "@tanstack/react-query"
import * as React from "react"
import * as ReactDOM from "react-dom/client"
import { createBrowserRouter } from "react-router"
import { RouterProvider } from "react-router/dom"
import { ColourSchemeProvider } from "./design-system/index.ts"
import "./design-system/tokens.css"
import { Toaster } from "./primitives/sonner.tsx"
import { TooltipProvider } from "./primitives/tooltip.tsx"
import { routes } from "./routes.tsx"
import { createQueryClient } from "./server-state/query-client.ts"

const router = createBrowserRouter(routes)
const queryClient = createQueryClient()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ColourSchemeProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster />
        </TooltipProvider>
      </ColourSchemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
